export const printFlagsList = {
  esg: {
    declaration: true,
    reshare: true,
    distribution: true,
    seudatagrid: true,
    yoy: true,
  },
};

export const tabToKey = (tabValue) => {
  switch (tabValue) {
    case 0:
      return 'consumption_overview';
    case 4:
      return 'esg';
    case 1:
      return 'energy_tree'; // assumes submenu default
    case 26:
      return 'energy_tree_overview';
    case 2:
      return 'energy_analysis_node';
    case 25:
      return 'energy_analysis_breakdown';
    case 24:
      return 'energy_analysis_hour';
    case 23:
      return 'energy_analysis_duration';
    case 21:
      return 'energy_analysis_compare';
    case 27:
      return 'energy_analysis_load_profile';
    case 3:
      return 'initiatives';
    default:
      return 'all';
  }
};
